import ContaReceberService from "@/services/ContaReceberService";
import moment from "moment";
import store from "@/store";
import helper from "@/helper";

export const actions = {
  async cadastrarContaReceber({ commit, dispatch }) {
    await commit("setShowInputAnexoContaReceber", false);
    await commit("setContaReceber", {
      cliente_id: "",
      situacao: "EM ABERTO",
      numero_documento: "",
      data_vencimento: moment().format("YYYY-MM-DD"),
      data_vencimento_original: moment().format("YYYY-MM-DD"),
      data_emissao: moment().format("YYYY-MM-DD"),
      data_competencia: moment().format("YYYY-MM-DD"),
      forma_pagamento: "",
      ocorrencia_tipo: "",
      ocorrencia: "PARCELA ÚNICA",
      ocorrencia_quantidade: 1,
      numero_parcela: 1,
      ocorrencia_quantidade: "",
      informacoes: "",
      anexo: "",
      portador_id: "",
      grupo_id: "",
      valor_pago: "0,00",
    }),
      await commit("setShowInputAnexoContaReceber", true);
    await dispatch("setModalCadastroContaReceber", true);
  },
  listarContaReceber: ({ commit }, data) => {
    commit("setOverlay", true);
    ContaReceberService.listar(data)
      .then((res) => {
        if (data.content == "pdf") {
          commit("setModalPrint", res.data.pdf_link);
        } else {
          commit("setContasReceber", res.data);
        }
        commit("setOverlay", false);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },

  baixarContaReceber: ({ commit, dispatch }, data) => {
    dispatch("setModalBaixaContaReceber", false);
    commit("setOverlay", true);
    ContaReceberService.baixar(data)
      .then((res) => {
        commit("setLancamentoBancario", {
          numero_documento: data.numero_documento,
          data_lancamento: moment().format("YYYY-MM-DD"),
          data_competencia: data.data_competencia,
          historico: `Baixa conta a receber Nº ${data.id}`,
          portador_id: data.portador_id,
          grupo_id: data.grupo_id,
          // banco_id: null,
          valor: data.valor_pago,
          tipo: "CRÉDITO",
          contato_id: data.cliente_id,
        });

        let index = store.getters.getFormasPagamento
          .map((x) => x.id)
          .indexOf(data.forma_pagamento_id);
        commit(
          "setFormaPagamentoSelecionadaLancamentoCaixa",
          store.getters.getFormasPagamento[index]
        );

        commit("setLancamentoCaixa", {
          forma_pagamento_id: data.forma_pagamento_id,
          forma_pagamento: "",
          valor: data.valor_pago,
          tipo: "RECEBIMENTOS DIVERSOS",
          historico: `Baixa conta a receber Nº ${data.id}`,
          data: moment().format("YYYY-MM-DD"),
        });

        dispatch("setModalCadastroLancamentoCaixa", true);
        commit("setContaReceber", {
          ...store.getters.getContaReceber,
          situacao: res.data.situacao,
          valor_pago: helper.formatReal(parseFloat(res.data.valor_pago)),
          extrato: res.data.extrato,
        });
        dispatch("setModalCadastroLancamentoBancario", true);
        dispatch("listarContaReceber", { limit: 20, situacao: "EM ABERTO" });
        commit("setOverlay", false);
        commit("snackbarSuccess", "Conta baixada com sucesso.");
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao baixar conta.");
      });
  },
  visualizarContaReceber: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    ContaReceberService.editar(data.id)
      .then((res) => {
        commit("setContaReceber", { ...res.data });
        dispatch("setModalCadastroContaReceber", true);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },

  salvarContaReceber: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    ContaReceberService.salvar(data)
      .then((res) => {
        commit("setShowInputAnexoContaReceber", false);
        commit("setContaReceber", res.data);
        dispatch("listarContaReceber", { situacao: "EM ABERTO", limit: 20 });
        commit("setOverlay", false);
        commit("snackbarSuccess", "Registro salvo.");
      })
      .then(() => {
        commit("setShowInputAnexoContaReceber", true);
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  atualizarContaReceber: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    ContaReceberService.atualizar(data)
      .then((res) => {
        commit("setShowInputAnexoContaReceber", false);
        dispatch("listarContaReceber", { limit: 20, situacao: "EM ABERTO" });
        commit("setOverlay", false);
        commit("snackbarInfo", "Registro atualizado.");
      })
      .then(() => {
        commit("setShowInputAnexoContaReceber", true);
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirContaReceber: ({ commit, dispatch }, data) => {
    dispatch("setModalExcluirContaReceber", false);
    dispatch("setModalCadastroContaReceber", false);
    commit("setOverlay", true);
    ContaReceberService.excluir(data.id)
      .then((res) => {
        commit("removeContaReceber", data);
        commit("setOverlay", false);
        commit("snackbarError", "Registro excluído.");
      })
      .catch((e) => {
        commit("snackbarError", "Erro ao excluir.");
      });
  },
  setModalCadastroContaReceber: ({ commit }, status) => {
    commit("setModalCadastrarContaReceber", false);
    setTimeout(() => {
      commit("setModalCadastrarContaReceber", status);
    }, 100);
  },
  setModalBaixaContaReceber: ({ commit }, status) => {
    commit("setModalBaixaContaReceber", false);
    setTimeout(() => {
      commit("setModalBaixaContaReceber", status);
    }, 100);
  },
  setModalExcluirContaReceber: ({ commit }, status) => {
    commit("setModalExcluirContaReceber", false);
    setTimeout(() => {
      commit("setModalExcluirContaReceber", status);
    }, 100);
  },
  gerarReciboTotalContaReceber:({commit}, data) => {
    commit('setOverlay', true);
    ContaReceberService.reciboTotal(data)
    .then(res => {
      commit('setOverlay', false);
      commit('setModalPrint', res.data.pdf_link)
    })
    .catch(e => {
      console.log(e)
      commit('setOverlay', false);
    })
  },
  gerarReciboParcialContaReceber:({commit}, data) => {
    commit('setOverlay', true);
    ContaReceberService.reciboParcial(data)
    .then(res => {
      commit('setOverlay', false);
      commit('setModalPrint', res.data.pdf_link)
    })
    .catch(e => {
      console.log(e)
      commit('setOverlay', false);
    })
  },
  setModalReciboTotalContaReceber: ({ commit }, status) => {
    commit("setModalReciboTotalContaReceber", false);
    setTimeout(() => {
      commit("setModalReciboTotalContaReceber", status);
    }, 100);
  },
  setModalReciboParcialContaReceber: ({ commit }, status) => {
    commit("setModalReciboParcialContaReceber", false);
    setTimeout(() => {
      commit("setModalReciboParcialContaReceber", status);
    }, 100);
  },
};

export default {};
